/* eslint-disable */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

const defaultTime = 30

const ToggleFetcherTimer = ({ callback }) => {

  const [isOn, setIsOn] = useState(false)
  const [time, setTime] = useState(defaultTime)
  const timer = useRef()

  const onToggle = (e) => {
    e.preventDefault()
    setIsOn(prevVal => !prevVal)
  }

  useEffect(() => {
    if(time === 0){
      setTime(defaultTime)
      callback()
    }
  }, [time])

  useEffect(() => {
    if(isOn){
      timer.current = setInterval(() => {
        
        setTime(prevVal => prevVal-1)
      }, 1000)
    }
    else{
      setTime(defaultTime)
      clearInterval(timer.current) 
    }

  }, [isOn])

  return (
    <div className="d-flex justify-content-start align-items-center flex-grow-1 ">
      <button
        className={`btn ${isOn ? 'btn-primary cms-bg-color-primary cms-outline-primary ' : 'btn-danger'} font-weight-bold px-2 py-4`}
        type="button"
        onClick={onToggle}
      >
        <i className="fa fa-clock py-1" />{` AUTO REFRESH ${isOn ? 'ON' : 'OFF'} ${isOn ? `${time} sec` : ''}`}
      </button>
    </div>      
  )
}

ToggleFetcherTimer.defaultProps = {
  callback: () => {},
}

ToggleFetcherTimer.propTypes = {
  callback: PropTypes.instanceOf(Function)
}

export default ToggleFetcherTimer